import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Plus, Trash, Flame, Check } from "@phosphor-icons/react";

export default function Habits() {
  const [habits, setHabits] = useState([]);
  const [name, setName] = useState("");

  const load = () => api.get("/habits").then((r) => setHabits(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try { await api.post("/habits", { name }); setName(""); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const check = async (id) => { await api.post(`/habits/${id}/check`); load(); };
  const remove = async (id) => { await api.delete(`/habits/${id}`); load(); };

  return (
    <div className="space-y-10">
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-sage font-bold mb-2">Habit tracker</p>
        <h1 className="font-serif text-4xl md:text-5xl font-medium">Quiet consistency.</h1>
      </div>

      <form onSubmit={add} className="flex gap-3">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. 10-minute walk"
               data-testid="habit-input"
               className="flex-1 px-5 py-3 rounded-full border border-border bg-white focus:outline-none focus:ring-2 focus:ring-sage" />
        <button type="submit" data-testid="habit-add"
                className="px-5 py-3 rounded-full bg-moss text-white hover:bg-mossDark inline-flex items-center gap-2">
          <Plus size={16} /> Add habit
        </button>
      </form>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {habits.length === 0 ? (
          <p className="text-muted-foreground col-span-2">Start with one small habit. Just one.</p>
        ) : habits.map((h) => (
          <div key={h.id} data-testid={`habit-${h.id}`}
               className="bg-white rounded-3xl border border-border p-6 soft-shadow flex items-center gap-4">
            <button onClick={() => check(h.id)} data-testid={`habit-check-${h.id}`}
                    className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                      h.checked_today ? "bg-moss text-white" : "bg-cream hover:bg-sage/30"
                    }`}>
              {h.checked_today ? <Check size={18} weight="bold" /> : <Flame size={18} weight="duotone" className="text-moss" />}
            </button>
            <div className="flex-1">
              <p className="font-medium">{h.name}</p>
              <p className="text-xs text-muted-foreground">
                {h.streak > 0 ? `${h.streak} day streak` : "Start your streak"}
              </p>
            </div>
            <button onClick={() => remove(h.id)} data-testid={`habit-delete-${h.id}`}
                    className="text-muted-foreground hover:text-destructive">
              <Trash size={18} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
